/**
 * Subscription tier definitions for Akem platform
 */
export var SubscriptionTier;
(function (SubscriptionTier) {
    SubscriptionTier["BASIC_CONNECT"] = "basic";
    SubscriptionTier["INVESTOR_PRO"] = "pro";
    SubscriptionTier["TRADER_ELITE"] = "elite";
    SubscriptionTier["ALPHA_SUITE"] = "alpha";
})(SubscriptionTier || (SubscriptionTier = {}));
